import gql from 'graphql-tag';
import { v4 as uuidv4 } from 'uuid';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class DepositoDocumentoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
        /********* PASO DE PARAMETROS ENTRE COMPONENTES EN DIFERENTES RUTAS *********/
        this.listaPayloads = [];
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: deposito_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  banco_codigo
                  empresa_rut
                  tipo_cuenta_bancaria_codigo
                  banco_codigo_cuenta_bancaria
                  numero_cuenta
                  descripcion
                  fecha_deposito
                  fecha_timbrado
                  monto
                  estado
                  pago_codigo
                  cliente_proveedor_rut
                  sucursal_codigo
                  numero_doc
                  banco_nombre_origen
                  fecha_ingreso
                  numero_cuenta_cheque
                  vendedor_codigo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTodosChequesSegunFiltros(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: deposito_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            obtenerTodosChequesSegunFiltros(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  fecha_vecimiento
                  fecha_ingreso
                  fecha_deposito
                  banco_codigo
                  banco_nombre_origen
                  numero_doc
                  cliente_proveedor_rut
                  cliente_proveedor_nombre
                  estado
                  banco_codigo_cuenta_bancaria
                  banco_nombre_destino
                  numero_deposito
                  monto
                  estado_nombre
                  estado
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.obtenerTodosChequesSegunFiltros;
            callback({ mensajes, respuesta });
        });
    }
    depositarDocumentosResumen(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            depositarDocumentosResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  empresa_rut
                  sucursal_codigo
                  banco_codigo
                  numero_doc
                  descripcion
                  monto
                  pago_codigo
                  cliente_proveedor_rut
                  banco_codigo_cuenta_bancaria
                  tipo_cuenta_bancaria_codigo
                  numero_cuenta
                  depositante_codigo
                  numero_deposito
                  fecha_deposito
                  depositante_rut
                  depositante_nombre
                  banco_nombre_origen
                  cantidad
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.depositarDocumentosResumen;
            callback({ mensajes, respuesta });
        });
    }
    depositarDocumentosDetalle(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            depositarDocumentosDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  empresa_rut
                  sucursal_codigo
                  banco_codigo
                  numero_doc
                  descripcion
                  monto
                  pago_codigo
                  cliente_proveedor_rut
                  banco_codigo_cuenta_bancaria
                  tipo_cuenta_bancaria_codigo
                  numero_cuenta
                  depositante_codigo
                  numero_deposito
                  fecha_deposito
                  depositante_rut
                  depositante_nombre
                  banco_nombre_origen
                  fecha_ingreso
                  numero_cuenta_cheque
                  vendedor_codigo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.depositarDocumentosDetalle;
            callback({ mensajes, respuesta });
        });
    }
    guardarPayload(payload) {
        const id = uuidv4();
        const mainPayload = {
            id,
            data: payload
        };
        this.listaPayloads.push(mainPayload);
        return id;
    }
    rescatarPayload(id) {
        return this.listaPayloads.filter(p => p.id === id);
    }
    /********* PASO DE PARAMETROS ENTRE COMPONENTES EN DIFERENTES RUTAS *********/
    agregarBancoDepositante(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: deposito_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            agregarBancoDepositante(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  empresa_rut
                  sucursal_codigo
                  banco_codigo
                  numero_doc
                  descripcion
                  monto
                  pago_codigo
                  cliente_proveedor_rut
                  banco_codigo_cuenta_bancaria
                  tipo_cuenta_bancaria_codigo
                  numero_cuenta
                  depositante_codigo
                  numero_deposito
                  fecha_deposito
                  depositante_rut
                  depositante_nombre
                  banco_nombre_origen
                  fecha_ingreso
                  numero_cuenta_cheque
                  vendedor_codigo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.agregarBancoDepositante;
            callback({ mensajes, respuesta });
        });
    }
    guardarDepositoDocumento(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: deposito_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            guardarDepositoDocumento(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  empresa_rut
                  sucursal_codigo
                  banco_codigo
                  numero_doc
                  descripcion
                  monto
                  pago_codigo
                  cliente_proveedor_rut
                  banco_codigo_cuenta_bancaria
                  tipo_cuenta_bancaria_codigo
                  numero_cuenta
                  depositante_codigo
                  numero_deposito
                  fecha_deposito
                  depositante_rut
                  depositante_nombre
                  fecha_ingreso
                  numero_cuenta_cheque
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.guardarDepositoDocumento;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDepositoTimbrarSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: deposito_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            obtenerDepositoTimbrarSegunFiltro(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                tipo
                texto
                codigo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  empresa_rut
                  sucursal_codigo
                  tipo_cuenta_bancaria_codigo
                  banco_codigo_cuenta_bancaria
                  banco_nombre_destino
                  numero_cuenta
                  fecha_deposito
                  fecha_timbrado
                  depositante_codigo
                  depositante_rut
                  depositante_nombre
                  monto
                  activo
                  numero_deposito
                  estado_timbrado
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.obtenerDepositoTimbrarSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDepositoTimbrarEspecifico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: deposito_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            obtenerDepositoTimbrarEspecifico(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                tipo
                texto
                codigo
                contexto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  empresa_rut
                  sucursal_codigo
                  numero_doc
                  fecha_ingreso
                  fecha_vecimiento
                  banco_codigo
                  banco_nombre_origen
                  cliente_proveedor_rut
                  cliente_proveedor_nombre
                  monto
                  activo
                  estado
                  estado_nombre
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.obtenerDepositoTimbrarEspecifico;
            callback({ mensajes, respuesta });
        });
    }
    guardarTimbradoDeposito(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad:deposito_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            guardarTimbradoDeposito(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes{
                tipo
                texto
                codigo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                 codigo
                  empresa_rut
                  sucursal_codigo
                  tipo_cuenta_bancaria_codigo
                  banco_codigo_cuenta_bancaria
                  banco_nombre_destino
                  numero_cuenta
                  fecha_deposito
                  fecha_timbrado
                  depositante_codigo
                  depositante_rut
                  depositante_nombre
                  monto
                  activo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.guardarTimbradoDeposito;
            callback({ mensajes, respuesta });
        });
    }
    obtenerExcelTodosChequesSegunFiltros(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: deposito_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            obtenerTodosChequesSegunFiltros(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rutaArchivo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.obtenerTodosChequesSegunFiltros;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPDFTodosChequesSegunFiltros(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: deposito_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_documento {
            obtenerTodosChequesSegunFiltros(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rutaArchivo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.deposito_documento.obtenerTodosChequesSegunFiltros;
            callback({ mensajes, respuesta });
        });
    }
}
DepositoDocumentoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DepositoDocumentoService_Factory() { return new DepositoDocumentoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: DepositoDocumentoService, providedIn: "root" });
